<style lang="scss" rel="stylesheet/scss" scoped>
#canvas {
  position: fixed;
}
.viewer-wrapper {
  background: #333;
  height: auto;
}
.pages {
  position: absolute;
  z-index: 999;
  left: 40%;
  top: 80px;
  width: 500px;
  font-size: 10px !important;
}
.item-menu {
  z-index: 1000;
}
.methods {
  margin-bottom: 1em;
  flex-wrap: wrap;
  & > * {
    margin-right: 0.75rem;
  }
}
.options-panel {
  .panel-block {
    padding: 0;
    .checkbox {
      display: block;
      width: 100%;
      margin: 0;
      padding: 0.5em 0.75em;
    }
  }
}
.viewer {
  height: 100%;
  .images {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px;
    .image-wrapper {
      display: inline-block;
      width: calc(33% - 20px);
      margin: 5px 5px 0 5px;
      .image {
        width: 100%;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}
.button {
  font-size: 10px;
}
</style>
<style scoped>
</style>
<template>
  <div>
    <div
      v-if="
        documentStatus &&
        user &&
        user.id != documentStatus.userId &&
        documentStatus.status == 'LOCKED'
      "
      style="
        text-align: center;
        font-size: 13px;
        padding: 100px 20px;
        min-height: 300px;
      "
    >
      <v-alert :value="true" type="info">
        {{ documentStatus.message }} .....
      </v-alert>
    </div>
    <div v-else>
      <div v-if="documentImage">
        <!-- 
          <v-btn v-on:click="activateCopy()" v-if="!copiable" color="success" small style="display:block; margin-left: auto; top: 0px; color: #fff;z-index: 10;">Enable Copy</v-btn>
      <v-btn v-on:click="disableCopy()" v-if="copiable" small  color="grey" style="display:block; margin-left: auto; top: 0px; z-index: 10;">Disable Copy</v-btn>-->
        <div class="text-xs-center" v-if="!viewOnly">
          <v-layout row wrap ma-0 pa-0 class="bg item-menu">
            <v-flex xs12>
              <v-btn
                color="blue-grey"
                class="white--text button"
                v-if="queryType != 'validation'"
                @click="openEmailDialog(item, true)"
              >
                <v-icon right dark>email</v-icon>&nbsp;&nbsp; Email
              </v-btn>
              <!-- <v-btn color="blue-grey" class="white--text" @click="loader = 'loading3'"> 
            <v-icon right dark>print</v-icon> &nbsp;&nbsp; Print
        </v-btn>-->
              <!-- <v-btn
                color="blue-grey"
                class="white--text button"
                @click="download()"
                v-if="queryType != 'validation'"
              >
                <v-icon right dark>cloud_download</v-icon>&nbsp;&nbsp; Download
              </v-btn> -->
              <template v-if="documentActionList.includes('update-document')">
              <v-btn
                v-if="documentType == 'HAWB' || documentType == 'MAWB'"
                color="blue-grey"
                class="white--text button"
                @click="awbDialog = true"
              >
                <v-icon right dark>edit</v-icon>&nbsp;&nbsp; Update AWB
              </v-btn>
              <v-btn
                v-if="
                  documentType == 'IMPORT_FLIGHTFILE' ||
                  documentType == 'EXPORT_FLIGHTFILE' ||
                  documentType == 'UNIDENTIFIED_FLIGHTFILE'
                "
                color="blue-grey"
                class="white--text button"
                @click="flightFileDialog = true"
              >
                <v-icon right dark>edit</v-icon>&nbsp;&nbsp; Update Flight File
              </v-btn>
              <v-btn
                v-if="
                  documentType == 'RELEASENOTE' ||
                  documentType == 'REMOVALAUTHORITY' ||
                  documentType == 'TRANSFERMANIFEST' ||
                  documentType == 'BULK_RELEASENOTE'
                "
                color="blue-grey"
                class="white--text button"
                @click="podDialog = true"
              >
                <v-icon right dark>edit</v-icon>&nbsp;&nbsp; Update POD File
              </v-btn>

              <v-btn
                v-if="documentType == 'COURIERFILE'"
                color="blue-grey"
                class="white--text button"
                @click="courierFileDialog = true"
              >
                <v-icon right dark>edit</v-icon>&nbsp;&nbsp; Update Courier File
              </v-btn>
              </template>
              <v-menu>
                <template #activator="{ on: menu }">
                  <v-tooltip bottom>
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        color="primary"
                        dark
                        v-on="{ ...tooltip, ...menu }"
                      >
                        More <v-icon right dark>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <span>Click to view menu items</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title v-on:click="openPage(item.id)"
                      >Download File</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-list-tile v-if="item && item.parent_id">
                    <v-list-tile-title
                      v-on:click="openPage(item.parent_id)"
                    >
                      Download Full File
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="documentActionList.includes('delete-document')">
                    <v-list-tile-title>
                      <delete-page
                        :item="item"
                        type="PAGE"
                        @completed="reInitialiseGrids"
                      />
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="documentActionList.includes('delete-document')">
                    <v-list-tile-title>
                      <delete-page
                        :item="item"
                        type="DOCUMENT"
                        @completed="reInitialiseGrids"
                      />
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="documentActionList.includes('convert-document')">
                    <v-list-tile-title>
                      <convert-document
                        :item="item"
                        :documentType="item.document_type"
                        type="PAGE"
                        @completed="reInitialiseGrids"
                      />
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="documentActionList.includes('convert-document')">
                    <v-list-tile-title>
                      <convert-document
                        :item="item"
                        :documentType="item.source_document_type"
                        type="FILE"
                        @completed="reInitialiseGrids"
                      />
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
        </div>
        <div class="pages">
          <v-flex xs12 sm6 d-flex>
            <v-btn
              class="button"
              v-if="prevPageId"
              v-on:click="setPage(prevPageId)"
            >
              Prev
            </v-btn>
            <v-select
              :items="pages"
              :value="selectedPage"
              item-text="name"
              item-value="id"
              label="Select Page"
              solo
              v-on:change="setPage($event)"
            ></v-select>
            <v-btn
              class="button"
              v-if="nextPageId"
              v-on:click="setPage(nextPageId)"
            >
              Next
            </v-btn>
            <v-btn
              class="button"
              v-if="item && selectedPage && item.id != selectedPage"
              v-on:click="setPage(item.id)"
            >
              Back To Page
            </v-btn>
          </v-flex>
        </div>
        <div
          class="viewer-wrapper"
          ref="viewerContainer"
          style
          v-if="chart && documentImage"
        >
          <div :options="options" class="viewer" ref="viewer">
            <img
              :src="documentImage"
              @load="startViewer"
              :key="documentImage"
              width="100%"
              ref="viewerImage"
            />
          </div>
        </div>
        <canvas
          v-show="copiable"
          ref="canvas"
          id="canvas"
          width="850"
          height="800"
          style="
            left: 0;
            top: 0;
            z-index: 8;
            border: 0px solid red;
            -webkit-transform: translate3d(0px, 0px);
            transform: translate3d(0px, 0px);
          "
        ></canvas>
            <v-dialog v-model="emailDialog" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Email Document
        </v-card-title>

        <v-card-text>
          <v-flex xs12>
            <v-text-field label="To" hint="You can add multiple emails separated by comma a (,)" v-model="emailProperties.to"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Subject" v-model="emailProperties.subject"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea label="Body" v-model="emailProperties.body"></v-textarea>
          </v-flex>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="emailDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="sendEmail()"
            :loading="emailProperties.loading"
          >
            Send 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog
          v-model="flightFileDialog"
          persistent
          max-width="300px"
          :hide-overlay="true"
        >
          <v-card style="position: fixed; top: 100px; left: 20px; width: 550px">
            <v-form
              id="search-form-FLIGHTFILE"
              data-vv-scope="FLIGHTFILE"
              @submit.prevent="updateDSSDocument(item.id, 'FLIGHTFILE', item)"
            >
              <v-card-title>
                <span class="headline">Update Flight File</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap v-if="item">
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        label="Flight Number"
                        v-model="item.flight_number"
                        name="flight_number"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('FLIGHTFILE.flight_number')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="FLIGHTFILE"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        :items="devices"
                        v-model="item.sender_address"
                        name="sender_address"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('FLIGHTFILE.sender_address')
                        "
                        item-text="name"
                        item-value="code"
                        label="Building"
                        outline
                        data-vv-scope="FLIGHTFILE"
                      ></v-select>
                      <!-- <v-text-field label="Building" v-model="item.building" outline placeholder=" "></v-text-field> -->
                    </v-flex>
                    <!-- <v-flex xs12 sm6 md6>
                  <v-text-field label="Origin" v-model="item.origin" outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field label="Destination" v-model="item.destination" outline placeholder=" "></v-text-field>
                </v-flex> -->
                    <v-flex xs12 sm6 md6>
                      <v-radio-group row v-model="item.document_type">
                        <v-radio
                          label="Import"
                          value="IMPORT_FLIGHTFILE"
                        ></v-radio>
                        <v-radio
                          label="Export"
                          value="EXPORT_FLIGHTFILE"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        label="Date (dd/mm/yyyy)"
                        mask="##/##/####"
                        v-model="item.flight_date"
                        name="flight_date"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('FLIGHTFILE.flight_date')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="FLIGHTFILE"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click="flightFileDialog = false"
                  >Close</v-btn
                >
                <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>


        <v-dialog
          v-model="courierFileDialog"
          persistent
          max-width="300px"
          :hide-overlay="true"
        >
          <v-card style="position: fixed; top: 100px; left: 20px; width: 550px">
            <v-form
              id="search-form-COURIERFILE"
              data-vv-scope="COURIERFILE"
              @submit.prevent="updateDSSDocument(item.id, 'COURIERFILE', item)"
            >
              <v-card-title>
                <span class="headline">Courier File</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap v-if="item">
                    <v-flex xs12 sm6 md6>
                      <v-select
                        :items="devices"
                        v-model="item.sender_address"
                        name="sender_address"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('COURIERFILE.sender_address')
                        "
                        item-text="name"
                        item-value="code"
                        label="Building"
                        outline
                        data-vv-scope="COURIERFILE"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        label="Date (dd/mm/yyyy)"
                        mask="##/##/####"
                        v-model="item.flight_date"
                        name="flight_date"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('COURIERFILE.flight_date')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="COURIERFILE"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click="courierFileDialog = false"
                  >Close</v-btn
                >
                <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="awbDialog" persistent :hide-overlay="true">
          <v-card style="position: fixed; top: 100px; left: 20px; width: 550px">
            <v-form
              id="search-form-MAWB"
              data-vv-scope="MAWB"
              @submit.prevent="updateDSSDocument(item.id, 'MAWB', item)"
            >
              <v-card-title>
                <span class="headline">Update AWB</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap v-if="item">
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        label="AWB Number (NNN - #########)"
                        mask="NNN - #########"
                        v-model="item.serialnumber"
                        name="serialnumber"
                        v-validate="'required'"
                        :error-messages="errors.collect('MAWB.serialnumber')"
                        outline
                        placeholder=" "
                        data-vv-scope="MAWB"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        :items="devices"
                        v-model="item.sender_address"
                        name="sender_address"
                        v-validate="'required'"
                        :error-messages="errors.collect('MAWB.sender_address')"
                        item-text="name"
                        item-value="code"
                        label="Building"
                        outline
                        data-vv-scope="MAWB"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Origin"
                        v-model="item.airport_departure"
                        name="airport_departure"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('MAWB.airport_departure')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="MAWB"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        label="Destination"
                        v-model="item.airport_destination"
                        name="airport_destination"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('MAWB.airport_destination')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="MAWB"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="awbDialog = false"
                  >Close</v-btn
                >
                <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="podDialog" persistent :hide-overlay="true">
          <v-card style="position: fixed; top: 100px; left: 20px; width: 550px">
            <v-form
              id="search-form-PODFILE"
              data-vv-scope="PODFILE"
              @submit.prevent="updateDSSDocument(item.id, 'PODFILE', item)"
            >
              <v-card-title>
                <span class="headline">Update POD File</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap v-if="item">
                    <v-flex xs6>
                      <v-select
                        :items="devices"
                        v-model="item.sender_address"
                        name="sender_address"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('PODFILE.sender_address')
                        "
                        item-text="name"
                        item-value="code"
                        label="Building"
                        outline
                        data-vv-scope="PODFILE"
                      ></v-select>
                    </v-flex>
                    <v-flex xs3 v-if="item.document_type == 'BULK_RELEASENOTE'">
                      <v-text-field
                        label="Page"
                        v-model="item.sub_page_number"
                        name="sub_page_number"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('PODFILE.sub_page_number')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="PODFILE"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 v-if="item.document_type == 'BULK_RELEASENOTE'">
                      <v-text-field
                        label="Cons. Count"
                        v-model="item.item_count"
                        name="item_count"
                        v-validate="'required'"
                        :error-messages="errors.collect('PODFILE.item_count')"
                        outline
                        placeholder=" "
                        data-vv-scope="PODFILE"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                        label="AWB Number(s) eg 999-99999999"
                        v-model="item.serialnumbers"
                        name="serialnumbers"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('PODFILE.serialnumbers')
                        "
                        outline
                        placeholder=" "
                        data-vv-scope="PODFILE"
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="podDialog = false"
                  >Close</v-btn
                >
                <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "viewerjs";
import { createNamespacedHelpers } from "vuex";

import JwtService from "@/services/jwt.service";

let user = JwtService.getUser();

const emailProperties = {
  to: "",
  subject: "",
  body: "See document attached.",
  loading: false
};

const chartNamespace = createNamespacedHelpers("charts");
import UsersService from "@/services/users.service";
import DeletePage from "@/components/charts/capture672/dialog/delete-page";
import ConvertDocument from "@/components/charts/capture672/dialog/convert-document";
import ApiService from "@/services/api.service";
import { aclMenu } from "@/models/user.js";

const { mapState } =
  createNamespacedHelpers("charts");

import {
  getDocumentUrl,
  updateDSSDocument,
  indexDocument,
  getPages,
  getDevices,
  getDocumentStatus,
  releaseDocument,
} from "@/models/awb";

// let canvas = null;
// let canvasContainer = null;
// let ctx = null;
// let rect = {startX: 0, startY: 0, w: 0, h: 0};
// let drag = false;
// let viewer = null;

export default {
  name: "image-viewer",
  props: ["chart"],
  data() {
    return {
      documentActionList: [],
      devices: [],
      viewOnly: true,
      item: null,
      imageCache: {},
      lastDocumentId: null,
      selectedPage: null,
      nextPageId: null,
      prevPageId: null,
      documentType: null,
      user: user,
      documentStatus: null,
      emailDialog: false,
      emailProperties: {...emailProperties},
      queryType: null,
      flightFileDialog: false,
      awbDialog: false,
      podDialog: false,
      courierFileDialog: false,
      params: {},
      documentImage: null,
      timeout: null,
      copiable: false,
      canvas: null,
      canvasContainer: null,
      ctx: null,
      rect: { startX: 0, startY: 0, w: 0, h: 0 },
      drag: false,
      viewer: null,
      options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: false,
        keyboard: false,
      },
      pages: [],
    };
  },
  components: {
    DeletePage,
    ConvertDocument,
  },
  computed: {
    ...mapState(["parameterisedFilterObject"]),
  },
  methods: {
    ...chartNamespace.mapActions(["aRefresh"]),
    ...chartNamespace.mapMutations(["mReInitializeGridsById"]),
    setDocumentActionList() {
      const documentActionList = ['convert-document', 'delete-document', 'update-document'];
      this.documentActionList = aclMenu(documentActionList);
    },
    openEmailDialog(item, parent) {
      this.emailProperties = {...emailProperties};
      this.emailProperties.parent = parent;
       this.emailProperties.item = item;
      if(typeof item.document_type != "undefined") {
        this.emailProperties.subject = item.document_type + " Document";
        this.emailProperties.body = item.document_type + " Attached";
       
      }

      if(parent) {
        this.emailProperties.subject = "File Attached";
        this.emailProperties.body = "See File Attached";
      }
      this.emailDialog = true;
    },
    async sendEmail() {
      this.emailProperties.loading = true;
      try {
        const id = this.emailProperties.item.id;
        if (id) {
          let url = "/ocr/email/document/" + id;
          if(this.emailProperties.parent) {
            url = "/ocr/email/document/full/" + id;
          }
          await ApiService.post(url, this.emailProperties);
          UsersService.trackEvent({
            model: "DOCUMENT",
            modelId: id,
            message: "Attachment Sent",
            reference: "EMAILED_ATTACHMENT",
            type: "EMAILED_ATTACHMENT",
          });
        }
      } catch (error) {
        console.log("email error", error);
      }

      this.emailProperties.loading = false;
      this.emailDialog = false;
    },
    async openPage(id) {
      // alert(JSON.stringify(params));
      const data = await getDocumentUrl(id);
      const url = data.url;
      window.open(url, "_blank");
      // alert(JSON.stringify(data));
    },
    reInitialiseGrids() {
      this.mReInitializeGridsById(this.chart.getParentId());
    },
    reset() {
      this.documentImage = null;
    },
    updateDSSDocument: async function (id, type, data) {
      const that = this;
      // alert("updateDSSDocument");
      if (type == "FLIGHTFILE") {
        // item.flight_number
        // if (data.flight_number && !data.flight_number.match(/^[A-Z]/i)) {
        //   alert("Enter a valid flight number");
        //   return;
        // }
        if (!data.flight_number || data.flight_number.length < 1) {
          alert("Enter a valid flight number");
          return;
        }
      }

      this.$validator
        .validateAll(type)
        .then(async function (response) {
          if (response === true) {
            // alert("validated");
            that.flightFileDialog = false;
            that.awbDialog = false;
            that.podDialog = false;
            that.courierFileDialog = false;
            const success = await updateDSSDocument(id, type, data);
            UsersService.trackEvent({
              model: "DOCUMENT",
              modelId: id,
              message: type + " : Document Validated",
              reference: type,
              type: "VALIDATE",
            });

            //if(this.documentType == 'IMPORT_FLIGHTFILE' || this.documentType == 'EXPORT_FLIGHTFILE') {
            await indexDocument(id);
            that.aRefresh();
            that.documentImage = null;
          } else {
            // alert("unvalidated");
          }
        })
        .catch(function (e) {
          // alert("error : " + e);
        });

      //}
    },
    disableCopy: function () {
      this.copiable = false;
    },
    activateCopy: function () {
      this.copiable = true;
      // this.canvas =  this.$refs.canvas;
      // this.canvasContainer =  this.$refs.canvasContainer;
      // this.ctx = this.canvas.getContext('2d');
      this.scaleCanvas();
    },
    scaleCanvas: function () {
      //this.viewer = this.viewer;
      // onSelect = this.onSelect;
      let viewerElement = this.$refs.viewer;
      if (!this.viewer) {
        console.log("viewer not found");
        return null;
      }

      if (!this.$refs.canvas) {
        console.log("no canvas");
        return false;
      }

      // this.canvas =  this.$refs.canvas;
      // this.canvasContainer =  this.$refs.canvasContainer;
      this.ctx = this.canvas.getContext("2d");

      let canvas = this.$refs.canvas;
      //
      // canvasContainer =  this.$refs.canvasContainer;
      // ctx = canvas.getContext('2d');

      this.rect = { startX: 0, startY: 0, w: 0, h: 0 };
      // drag = false;

      let img = this.viewer.image;
      let prop = this.getProperties(img);
      let viewerProp = this.getProperties(viewerElement);

      console.log("viewer", this.viewer);
      console.log("viewerElement", viewerElement);
      console.log("img", img);

      // prop.naturalHeight = img.naturalHeight;
      // prop.naturalWidth = img.naturalWidth;
      prop.marginLeft = img.offsetLeft;
      prop.marginTop = img.offsetTop;
      prop.clientWidth = img.clientWidth;
      prop.clientHeight = img.clientHeight;

      canvas.width = prop.clientWidth;
      canvas.height = prop.clientHeight;
      //canvasContainer.style.width = prop.clientWidth + "px";
      //canvasContainer.style.height = prop.clientHeight + "px";
      //canvasContainer.style.marginTop = prop.clientHeight + "px";
      canvas.style.position = "fixed";
      //canvas.style.top = img.y + window.scrollY + "px";
      canvas.style.top = img.y + "px";
      canvas.style.left = img.x + "px";

      // canvas.style.transform = "translate3d(" + canvas.style.left + "px," + canvas.style.top + "px)";
      // canvas.style.webkitTransform = "translate3d(" + canvas.style.left + "px," + canvas.style.top + ")";

      console.log(
        "img.getBoundingClientRect().top",
        img.getBoundingClientRect().top
      );
      // console.log("window.scrollY", window.scrollY);
      // console.log("window.pageYOffset", window.pageYOffset);

      // canvas.x = img.x;
      // canvas.y = img.y;

      // console.log("viewerProp", viewerProp);
      // console.log("viewer", viewer);
      console.log("prop", prop);
      // console.log("canvas.style", canvas.style);
    },
    startViewer: function () {
      if (this.viewer) {
        this.viewer.destroy();
      }

      let that = this;

      //onSelect = this.onSelect;
      let viewerElement = this.$refs.viewer;
      this.canvas = this.$refs.canvas;
      this.canvasContainer = this.$refs.canvasContainer;
      this.ctx = this.canvas.getContext("2d");
      this.rect = { startX: 0, startY: 0, w: 0, h: 0 };

      viewerElement.addEventListener("zoomed", function () {
        that.scaleCanvas();
      });

      this.init();
      //resizeCanvas();

      this.options.viewed = function () {
        // console.log("angle", that.angle);
        if (that.angle) {
          console.log("rotate", -that.angle);

          this.viewer.rotate(-that.angle);
        }
        // that.activateCopy();.o
        // that.disableCopy();
        // that.activateCopy();
      };

      this.viewer = new Viewer(this.$refs.viewer, this.options);
      // this.viewer = viewer;

      // let viewerImage = this.viewer.image;

      // console.log("this.$refs.viewer", this.$refs.viewer);
      // console.log("viewer", viewer);
    },
    init: async function () {
      // console.log("ctx");
      // if (
      //   this.parameterisedFilterObject &&
      //   typeof this.parameterisedFilterObject.attr_data
      // ) {
      //   this.item = JSON.parse(this.parameterisedFilterObject.attr_data);
      //   this.selectedPage = this.item.id;
      //   this.documentType =
      //     this.item && typeof this.item.document_type != "undefined"
      //       ? this.item.document_type
      //       : null;
      //   // getPages
      // }
      // alert(id);
      // console.log("item", this.item);
      // if (this.canvas) {
      //   this.canvas.addEventListener("mousedown", this.mouseDown, false);
      //   this.canvas.addEventListener("mouseup", this.mouseUp, false);
      //   this.canvas.addEventListener("mousemove", this.mouseMove, false);
      // }
    },
    updatePagination(value) {
      const page = this.pages.find((page) => page.id == value);
      const index = this.pages.indexOf(page);
      this.nextPageId =
        typeof this.pages[index + 1] != "undefined" && this.pages[index + 1]
          ? this.pages[index + 1].id
          : null;
      this.prevPageId =
        typeof this.pages[index - 1] != "undefined" && this.pages[index - 1]
          ? this.pages[index - 1].id
          : null;
    },
    async reSetPage() {
      this.selectedPage = this.item.id;
      this.updatePagination(this.selectedPage);
      this.setPage(this.selectedPage);
    },
    async setPage(value) {
      const page = this.pages.find((page) => page.id == value);
      this.updatePagination(value);

      const that = this;
      if (page) {
        this.selectedPage = page.id;
        // that.documentImage = null;
        if (typeof page.id != "undefined") {
          const data =
            typeof this.imageCache[page.id] != "undefined"
              ? this.imageCache[page.id]
              : await getDocumentUrl(page.id);
          const url = data.url;
          this.imageCache[page.id] = data;
          if (typeof page.angle != "undefined") {
            that.angle = parseInt(page.angle);
          }
          that.documentImage = url;
        }
      }
    },
    setPages(pages) {
      const item = this.item;
      this.pages = pages.map((page) => {
        page.name = "Page - " + page.page_number;
        return page;
      });

      this.updatePagination(this.selectedPage);
    },
    pageSelected() {},
    mouseDown: function (e) {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      this.rect.startX = e.pageX - canvas.offsetLeft;
      this.rect.startY = e.pageY - canvas.offsetTop - window.scrollY;

      // console.log("this.rect", this.rect);
      // console.log("e.pageX", e.pageX);
      // console.log("e.offsetLeft", e.offsetLeft);
      // console.log("canvas.offsetLeft", canvas.offsetLeft);

      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.drag = true;
    },
    mouseUp: function () {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      this.drag = false;
      let imageProperties = this.getImageProperties();
      imageProperties.selection = { ...rect };
      let scaled = this.scaleProperties(imageProperties);
      // ctx.clearRect(0,0,canvas.width,canvas.height);
      // console.log("imageProperties", imageProperties);
      // console.log("scaled", scaled);
      try {
        this.onSelect(scaled);
      } catch (err) {
        console.log("onSelectError", err);
      }

      rect.w = 0;
      rect.h = 0;
    },
    scaleProperties: function (prop) {
      let result = {};
      result.x = (prop.selection.startX * prop.naturalWidth) / prop.clientWidth;
      result.w = (prop.selection.w * prop.naturalWidth) / prop.clientWidth;
      result.y =
        (prop.selection.startY * prop.naturalHeight) / prop.clientHeight;
      result.h = (prop.selection.h * prop.naturalHeight) / prop.clientHeight;
      return result;
    },
    offset: function (el) {
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    },
    getProperties: function (el) {
      let prop = this.offset(el);

      // prop.naturalHeight = el.naturalHeight;
      // prop.naturalWidth = el.naturalWidth;
      prop.marginLeft = el.offsetLeft;
      prop.marginTop = el.offsetTop;
      prop.clientWidth = el.clientWidth;
      prop.clientHeight = el.clientHeight;
      return prop;
    },
    getImageProperties: function () {
      let img = this.viewer.image;
      let prop = this.getProperties(img);
      prop.naturalHeight = img.naturalHeight;
      prop.naturalWidth = img.naturalWidth;
      prop.marginLeft = img.offsetLeft;
      prop.marginTop = img.offsetTop;
      prop.clientWidth = img.clientWidth;
      prop.clientHeight = img.clientHeight;
      return prop;
    },
    mouseMove: function (e) {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      if (this.drag) {
        console.log("dragging");
        this.rect.w = e.pageX - canvas.offsetLeft - rect.startX;
        this.rect.h = e.pageY - canvas.offsetTop - rect.startY - window.scrollY;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.draw();
      }
    },
    draw: function () {
      let ctx = this.ctx;
      let rect = this.rect;
      let canvas = this.canvas;

      ctx.setLineDash([6]);
      ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
    },
    async download() {
      const params = this.params;
      if (typeof params.id != "undefined") {
        const data = await getDocumentUrl(params.id);
        const url = data.url;
        // alert(url);
        window.open(url, "_blank");
        // alert(JSON.stringify(url));
      }
    },
    setAngleUsingAttrData(params) {
      this.angle = 0;
      try {
        const data = JSON.parse(params.attr_data);
        if (typeof data.angle != "undefined" && data.angle) {
          this.angle = parseInt(data.angle);
        } else {
          //
        }
      } catch (error) {
        //
      }
    },
  },

  beforeMount() {
    const that = this;

    this.chart.showInImageViewer = async function (params) {
      // alert(JSON.stringify(params.id));
      // console.log(
      //   "that.parameterisedFilterObject",
      //   that.parameterisedFilterObject
      // );

      if (
        that.parameterisedFilterObject &&
        typeof that.parameterisedFilterObject.attr_data != "undefined"
      ) {
        that.item = JSON.parse(that.parameterisedFilterObject.attr_data);
        that.selectedPage = that.item.id;
        that.updatePagination(that.selectedPage);

        if (typeof that.item.attr_viewonly == "undefined") {
          that.viewOnly = false;
        }

        that.documentType =
          that.item && typeof that.item.document_type != "undefined"
            ? that.item.document_type
            : null;
        that.queryType =
          that.item && typeof that.item.query_type != "undefined"
            ? that.item.query_type
            : null;

        // getPages
      }

      that.documentImage = null;
      // console.log("parameterisedFilterObject", that.parameterisedFilterObject);
      if (typeof params.id != "undefined") {
        // if(params.id)

        if (that.lastDocumentId && params.id != that.lastDocumentId) {
          releaseDocument(that.lastDocumentId);
        }
        // releaseDocument

        const data = await getDocumentUrl(params.id);
        that.imageCache[params.id] = data;
        const url = data.url;
        that.params = params;
        that.documentImage = url;
        that.setAngleUsingAttrData(params);
        const documentStatus = await getDocumentStatus(params.id);
        that.documentStatus = documentStatus;
        // console.log("documentStatus", documentStatus);
        // console.log("user", that.user);
        // alert(JSON.stringify(url));
      }

      // console.log("that.item", that.item);
      if (that.item && typeof that.item.parent_id != "undefined") {
        const parentId = that.item.parent_id;
        const pages = await getPages(parentId);
        that.setPages(pages);
      }
    };
  },
  mounted: async function () {
    // alert("hey");

    // console.log("mounted 1");
    this.setDocumentActionList();
    this.reset();
    // let canvas = null;
    // let canvasContainer = null;
    // let ctx = null;
    // let rect = {startX: 0, startY: 0, w: 0, h: 0};
    // let drag = false;
    // let viewer = null;
    //
    // let onSelect = function(scaled) {
    //
    // }

    // function mouseDown(e) {
    //   rect.startX = e.pageX - this.offsetLeft;
    //   rect.startY = (e.pageY - this.offsetTop)-window.scrollY;
    //   ctx.clearRect(0,0,canvas.width,canvas.height);
    //   drag = true;
    // }

    // function mouseUp() {
    //   drag = false;
    //   let imageProperties = getImageProperties();
    //   imageProperties.selection = {...rect};
    //   let scaled = scaleProperties(imageProperties);
    //   // ctx.clearRect(0,0,canvas.width,canvas.height);
    //   // console.log("imageProperties", imageProperties);
    //   // console.log("scaled", scaled);
    //   try {
    //     onSelect(scaled);
    //   } catch(err) {
    //     console.log("onSelectError", err);
    //   }
    //
    //
    //   rect.w = 0;
    //   rect.h = 0;
    // }
    // function mouseMove(e) {
    //
    //   if (drag) {
    //     console.log("dragging");
    //     rect.w = (e.pageX - this.offsetLeft) - rect.startX;
    //     rect.h = ((e.pageY - this.offsetTop) - rect.startY)-window.scrollY ;
    //     ctx.clearRect(0,0,canvas.width,canvas.height);
    //     draw();
    //   }
    // }

    // function draw() {
    //   //console.log("ctx", ctx);
    //   //console.log("draw", rect);
    //   ctx.setLineDash([6]);
    //   ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
    // }

    // function offset(el) {
    //   var rect = el.getBoundingClientRect(),
    //   scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    //   scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //   return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    // }

    // function absolutePosition(el) {
    //     var found,
    //         left = 0,
    //         top = 0,
    //         width = 0,
    //         height = 0,
    //         offsetBase = absolutePosition.offsetBase;
    //     if (!offsetBase && document.body) {
    //         offsetBase = absolutePosition.offsetBase = document.createElement('div');
    //         offsetBase.style.cssText = 'position:absolute;left:0;top:0';
    //         document.body.appendChild(offsetBase);
    //     }
    //     if (el && el.ownerDocument === document && 'getBoundingClientRect' in el && offsetBase) {
    //         var boundingRect = el.getBoundingClientRect();
    //         var baseRect = offsetBase.getBoundingClientRect();
    //         found = true;
    //         left = boundingRect.left - baseRect.left;
    //         top = boundingRect.top - baseRect.top;
    //         width = boundingRect.right - boundingRect.left;
    //         height = boundingRect.bottom - boundingRect.top;
    //     }
    //     return {
    //         found: found,
    //         left: left,
    //         top: top,
    //         width: width,
    //         height: height,
    //         right: left + width,
    //         bottom: top + height
    //     };
    // }

    // function resizeCanvas() {
    //   // canvas.width = window.innerWidth;
    //   // canvas.height = window.innerHeight;
    //   //console.log("window.innerWidth", window.innerWidth);
    //
    //   /**
    //   * Your drawings need to be inside this function otherwise they will be reset when
    //   * you resize the browser window and the canvas goes will be cleared.
    //   */
    //   //drawStuff();
    // }

    // function getProperties(el) {
    //   let prop = offset(el);
    //
    //   // prop.naturalHeight = el.naturalHeight;
    //   // prop.naturalWidth = el.naturalWidth;
    //   prop.marginLeft = el.offsetLeft;
    //   prop.marginTop = el.offsetTop;
    //   prop.clientWidth = el.clientWidth;
    //   prop.clientHeight = el.clientHeight;
    //   return prop;
    // }

    // function scaleProperties(prop) {
    //   let result = {};
    //   result.x = (prop.selection.startX*prop.naturalWidth)/prop.clientWidth;
    //   result.w = (prop.selection.w*prop.naturalWidth)/prop.clientWidth;
    //   result.y = (prop.selection.startY*prop.naturalHeight)/prop.clientHeight;
    //   result.h = (prop.selection.h*prop.naturalHeight)/prop.clientHeight;
    //   return result;
    // }

    // function getImageProperties() {
    //   let img = viewer.image;
    //   let prop = getProperties(img);
    //   prop.naturalHeight = img.naturalHeight;
    //   prop.naturalWidth = img.naturalWidth;
    //   prop.marginLeft = img.offsetLeft;
    //   prop.marginTop = img.offsetTop;
    //   prop.clientWidth = img.clientWidth;
    //   prop.clientHeight = img.clientHeight;
    //   return prop;
    // }

    // this.canvas =  this.$refs.canvas;
    //
    // this.canvasContainer =  this.$refs.canvasContainer;
    // this.ctx = canvas.getContext('2d');

    // onSelect = this.onSelect;
    this.scaleCanvasTimeout = null;
    let that = this;

    // this.startViewer();
    console.log("startViewer");

    //this.activateCopy();
    // this.activateCopy();
    //this.timeout = setTimeout(this.activateCopy, 5000);

    let scaleCanvas = function () {
      if (that.scaleCanvasTimeout) {
        clearTimeout(that.scaleCanvasTimeout);
      }

      that.scaleCanvasTimeout = setTimeout(that.scaleCanvas, 300);
    };

    // window.addEventListener("resize", scaleCanvas);
    // window.addEventListener("scroll", scaleCanvas);

    this.devices = await getDevices();
    // console.log("this.devices", this.devices);

    // window.addEventListener('resize', this.scaleCanvas, false);
  },
  beforeDestroy() {
    const that = this;
    console.log("destroying");
    window.removeEventListener("resize", this.scaleCanvas);
    window.removeEventListener("scroll", this.scaleCanvas);

    if (this.scaleCanvasTimeout) {
      clearTimeout(this.scaleCanvasTimeout);
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    try {
      if (that.lastDocumentId) {
        releaseDocument(that.lastDocumentId);
      }
    } catch (error) {}
  },
};
</script>
